export const SKELETON_IDS = {
  HOME: 4,
  PROMOTION_COMMUN: 5,
  PROMOTION_BAPRO: 6,
  FOOTER: 13
};
